import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import "@/style/global.css";
import { EffectCards } from "swiper/modules";

type ReusableSwiperProps<T> = {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  spaceBetween?: number;
  slidesPerView?: number;
  onSlideChange?: (arg?: any) => void;
  onSwiperInit?: (swiper: any) => void;
  activeIndex?: number;
};

const StackedImageSlider = <T,>({
  items,
  renderItem,
  spaceBetween = 20,
  slidesPerView = 1,
  onSlideChange,
  onSwiperInit,
  activeIndex = 0,
}: ReusableSwiperProps<T>) => {
  const swiperRef = useRef<any>(null);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(activeIndex);
    }
  }, [activeIndex]);
  return (
    <Swiper
      effect={"cards"}
      grabCursor={true}
      dir="rtl"
      modules={[EffectCards]}
      className="mySwiper"
      onSlideChange={(swiper: any) => {
        if (onSlideChange) onSlideChange(swiper);
      }}
      onSwiper={(swiper: any) => {
        swiperRef.current = { swiper };
        if (onSwiperInit) onSwiperInit(swiper);
      }}
      style={{
        width: "304px",
        height: "auto !important",
        margin: "0 auto",
      }}
    >
      {items.map((item, index) => (
        <SwiperSlide style={{ height: "auto !important" }} key={index}>
          {renderItem(item, index)}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default StackedImageSlider;
